/* eslint-disable react/react-in-jsx-scope */

import FormTextInput from '../../../../components/forms/elements/FormTextInput'

const DownloadParticipantFormManualContent = ({ formDisabled }) => [
  {
    id: 'download-participant-form-manual-details',
    name: 'Enter Event ID',
    inputs: [
      {
        id: 'eventId',
        size: 12,
        field: (
          <FormTextInput
            name="eventId"
            label="Event ID"
            autoComplete="new-eventId"
            disabled={formDisabled}
            required
          />
        ),
      },
    ],
  },
]
export default DownloadParticipantFormManualContent
